import {
  REQUIRED_FIELD_ERROR,
  FIELD_INVALID,
  MOBILE_OR_LANDLINE,
  REQUIRED_FIELD_ERROR_FEM,
} from '@masfront/common-b2c'
import { object, string } from 'yup'

export const SalesLeadSchema = object().shape({
  brand: string()
    .label('marca')
    .when('product', {
      is: 'security_mm',
      then: string().test(
        'checkRightBrandMasmovil',
        'Para MASMovil Alarma Lead la marca tiene que ser Masmovil',
        (value: string) => value === 'Masmovil',
      ),
      otherwise: string(),
    })
    .when('product', {
      is: 'security',
      then: string().test(
        'checkRightBrandYoigo',
        'Para Alarmas HomeGO la marca tiene que ser Yoigo',
        (value: string) => value === 'Yoigo',
      ),
      otherwise: string(),
    })
    .when('product', {
      is: 'familyhealth',
      then: string().test(
        'checkRightBrandYoigoHealth',
        'Para Seguro Pack Familiar DoctorGO la marca tiene que ser Yoigo',
        (value: string) => value === 'Yoigo',
      ),
      otherwise: string(),
    })
    .trim()
    .required(REQUIRED_FIELD_ERROR),
  product: string().label('producto').trim().required(REQUIRED_FIELD_ERROR),
  name: string().label('nombre').trim().required(REQUIRED_FIELD_ERROR),
  surname1: string().label('apellido').trim().required(REQUIRED_FIELD_ERROR),
  sellerCode: string().label('código vendedor').trim(),
  telephoneNumber: string()
    .label('teléfono de contacto')
    .matches(MOBILE_OR_LANDLINE, FIELD_INVALID)
    .trim()
    .required(REQUIRED_FIELD_ERROR),
  segment: string().label('segmento').trim().required(REQUIRED_FIELD_ERROR),
  contactHour: string()
    .label('hora de contacto')
    .when(['segment', 'brand'], {
      is: (segment, brand) =>
        segment === 'residential' && (brand === 'Yoigo' || brand === 'Masmovil'),
      then: string().trim().required(REQUIRED_FIELD_ERROR_FEM),
      otherwise: string(),
    }),
})

export const salesLeadsValues = {
  brand: 'Masmovil',
  product: '',
  name: '',
  surname1: '',
  sellerCode: '',
  telephoneNumber: '',
  segment: 'residential',
  contactHour: '',
}

export interface LeadsValues {
  brand: string
  product: string
  name: string
  surname1: string
  sellerCode: string
  telephoneNumber: string
  segment: string
  contactHour: string
}
